const PROVIDER_LABELS = {
  groq: "Groq",
  openai: "OpenAI",
  claude: "Claude",
  vllm: "vLLM",
};

const payloadFrom = (error) => error?.response?.data || error || {};

export const isLlmProviderNotConfigured = (error) =>
  payloadFrom(error).code === "llm_provider_not_configured";

export function getLlmProviderErrorMessage(error) {
  if (!isLlmProviderNotConfigured(error)) return null;
  const provider = payloadFrom(error).provider;
  const label = PROVIDER_LABELS[provider] || "Selected";
  return `The ${label} LLM provider is not configured. Contact your on-prem superadmin.`;
}
